// src/features/dashboard/services/kpiApi.ts

import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';

import type {
  KpiTrendRequest,
  KpiTrendResponse,
} from '../types/kpiTrend.types';

export const getKpiCardsApi = async (
  payload: KpiTrendRequest,
): Promise<KpiTrendResponse> => {

  const token =
    sessionStorage.getItem(
      'token'
    );

  const response =
    await api.post<KpiTrendResponse>(
      ENDPOINTS.KPI_TREND,
      payload,
      {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      },
    );

  return response.data;
};